var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPath22(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.503,
    height: 39.252,
    viewBox: "0 0 44.503 39.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M27.25,41.1a4.44,4.44,0,0,1-5.983-.022l-.245-.222C9.345,30.293,1.715,23.376,2,14.745A12.143,12.143,0,0,1,7.209,5.2,12.89,12.89,0,0,1,24.248,7.65,12.866,12.866,0,0,1,41.286,5.2a12.143,12.143,0,0,1,5.2,9.542c.311,8.63-7.34,15.548-19.018,26.158l-.222.2Z",
    transform: "translate(-1.996 -2.999)",
    fill: "rgba(0,0,0,0.3)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath22);
export default __webpack_public_path__ + "static/media/Path_22.76c2205540dd820f0ab2246a1dacf5cf.svg";
export { ForwardRef as ReactComponent };